import { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Spinner } from './assets/component/initComponent';
import LenisProvider from './ScrollLenisProvider';

import './assets/css/style.css';
import App from './App';
// const LazyApp = lazy(() => import('./App'));

function MyApp(){

	useEffect(() => {
		const loader = document.getElementById('first-loader');
		if(loader){
			loader.classList.add('fade');
			setTimeout(()=> loader.remove(), 400);
		}
	}, []);

	const theme = createTheme({
		breakpoints: {
			values: {
				xs: 0,      // phones
				sm: 600,    // large phones / small tablets
				md: 900,    // tablets (landscape start)
				lg: 1200,   // laptops
				xl: 1536    // large desktops
			}
		},
		palette: {
			mode: 'light',
			primary: {
				main: '#5B31A1'
			},
			secondary: {
				main: '#001630'
			},
			text: {
				primary: '#001630'
			},
			error: {
				main: '#FF5630'
			},
			warning: {
				main: '#FFAB00'
			},
			success: {
				main: '#22C55E'
			},
			divider: '#e0e0e0'
		},
		typography: {
			fontFamily: 'Nunito, sans-serif',
			h1: { fontSize: '25px', fontWeight: 700, color: 'primary' },
			h2: { fontSize: '23px', fontWeight: 700, color: 'primary' },
			h3: { fontSize: '21px', fontWeight: 500, color: 'primary' },
			h4: { fontSize: '19px', fontWeight: 600, color: 'primary' },
			h5: { fontSize: '17px', fontWeight: 600, color: 'primary' },
			h6: { fontSize: '16px', fontWeight: 600, color: 'primary' },
			body1: { fontSize: 15 },
			body2: { fontSize: 15 }
		},
		components: {
			MuiTooltip: {
				arrow: true
			},
			MuiButton:{
				defaultProps: {
					variant:'contained'
				},
				styleOverrides: {
					root: {
						textTransform:'capitalize',
						fontsize:'13px'
					}
				}
			},
			MuiIconButton: {
				defaultProps: {
					size: 'small'
				}
			},
			MuiTextField: {
				defaultProps: {
					fullWidth:true,
					variant:'standard'
				},
				styleOverrides: {
					root: {
						'&.appInput': {
							width: '100%',

							'& .MuiInput-root': {
								// padding: 0
							},
							'& .MuiInputBase-root': { borderRadius: '8px' },
							'& .MuiInputBase-input': {
								padding: '16px 10px 10px 20px' // actual text padding
							}
						}
					}
				}
			},
			MuiSelect:{
				defaultProps: {
					fullWidth:true,
					variant:'standard'
				}
			}
		}
	});

	return (
		<LenisProvider>
			<ThemeProvider theme={theme}>
				<Suspense fallback={<Spinner/>}>
					<App />
				</Suspense>
			</ThemeProvider>
		</LenisProvider>
	);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<MyApp />);
